import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography, Button } from '@mui/material';
import UniversityReview from './UniversityReview';
import CourseReview from './CourseReview';
import SpecializationReview from './SpecializationReview';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { BackArrowIcon } from '../../icons';
import { useSelector } from 'react-redux';

const AdminReview = () => {
  const location = useLocation()
  const paginationSlice = useSelector(state=>state.pagination)
  const [tabIndex, setTabIndex] = useState(paginationSlice?.activeTab || 0);
  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ width: '100%',}}> 
      <Tabs  sx={{ width: '100%', px:2, position:'sticky', top: '70px', background: '#fff', borderBottom: '1px solid #ccc',    zIndex: 9, }}
        value={tabIndex}
        onChange={handleChange}
        aria-label="admin review tabs"
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab label="University" />
        <Tab label="Course" />
        <Tab label="Specialization" />
      </Tabs>

      <Box sx={{ p:0 }}>
        {tabIndex === 0 && <><UniversityReview isHeadHide={false} activeTab={tabIndex} module="admin" type={"university"}/></>}
        {tabIndex === 1 && <><CourseReview  isHeadHide={false} activeTab={tabIndex} module="admin" type={"course"}/></>}
        {tabIndex === 2 && <><SpecializationReview  isHeadHide={false} activeTab={tabIndex} module="admin" type={"specialization"}/></>}
      </Box>
    </Box>
  );
};

export default AdminReview;
